import React from "react";

import FeedbackIcon from "@uui/Announcement03";
import CheckIcon from "@uui/Check";
import ErrorIcon from "@uui/XCircle";
import CloseIcon from "@uui/XClose";

import { IconButton } from "@mui/material";
import styled from "@mui/material/styles/styled";
import Typography from "@mui/material/Typography";

import IconBackground from "@rui/IconBackground";
import { Column, Row } from "@rui/Stack";

export const BaseFeedbackSnackbarContent = styled(Column)(({ theme }) => ({
  borderRadius: theme.corners.base,
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  backgroundColor: "#FFF",
  maxWidth: "100%",
  boxShadow: theme.shadows[4],
  padding: theme.spacing(2, 3),
}));

const CloseButton = styled(IconButton)(({ theme }) => ({
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  borderRadius: theme.corners.base,
  height: theme.sizes.icon.large,
  width: theme.sizes.icon.large,
}));

export const FEEDBACK_ICON_BY_TYPE = {
  pending: (
    <IconBackground height={28} sx={{ bgcolor: "shades.orange.50" }}>
      <FeedbackIcon sx={{ color: "shades.orange.500" }} />
    </IconBackground>
  ),
  error: (
    <IconBackground height={28} sx={{ bgcolor: "shades.negative.50" }}>
      <ErrorIcon sx={{ color: "shades.negative.500" }} />
    </IconBackground>
  ),
  success: (
    <IconBackground height={28} sx={{ bgcolor: "shades.meadow.50" }}>
      <CheckIcon sx={{ color: "shades.meadow.500" }} />
    </IconBackground>
  ),
};

export const FeedbackSnackbarHeader = ({
  icon,
  onClose,
  subtitle,
  title,
}: {
  icon: "pending" | "error" | "success";
  onClose?: () => void;
  subtitle?: string;
  title: string;
}) => (
  <Column flex={1}>
    <Row variant="apart" flex={1}>
      <Row variant="left" spacing={1}>
        {FEEDBACK_ICON_BY_TYPE[icon]}
        <Typography variant="h2" color="shades.neutral.700">
          {title}
        </Typography>
      </Row>
      {onClose && (
        <CloseButton size="small" onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      )}
    </Row>
    {subtitle && (
      <Typography
        variant="labelReg"
        color="shades.neutral.500"
        marginLeft="36px"
      >
        {subtitle}
      </Typography>
    )}
  </Column>
);

export const FeedbackIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.transparent.black[20],
  color: "#FFF",
  borderRadius: "8px",
  padding: theme.spacing(2),
  "& .MuiSvgIcon-root": {
    fontSize: "16px",
  },
  "&:hover": {
    backgroundColor: theme.palette.transparent.black[40],
  },
}));
